@if (options; as options) {
  <div class="snackbar z-fx-sc z-fx-gap-32 zef-bgcolor-ink zef-shadow-4 zef-text-overflow-line">
    <span class="zef-text-p1 z-fx-grow zef-text-ellipsis">
      @if (!options.noticeTemplate) {
        {{ data.title }}
      } @else {
        <ng-template [ngTemplateOutlet]="options.noticeTemplate"></ng-template>
      }
    </span>
    <div class="z-fx z-fx-center-end z-fx-gap-4">
      @if (options.actionName) {
        <button mat-raised-button color="stealth" (click)="onAction()">
          {{ options.actionName }}
        </button>
      }

      @if (!options.persistent) {
        <button mat-icon-button color="stealth" (click)="dismiss()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    <div class="snackbar-status" [ngClass]="'zef-bgcolor-' + (options.color || 'primary')"></div>
  </div>
}
